export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.enterprise-knowledge-graph': '企業知識圖譜中心',
  'menu.enterprise-knowledge-graph.dashboard': '工作台',
  'menu.enterprise-knowledge-graph.entities': '我的實體',
  'menu.enterprise-knowledge-graph.entities.list': '全部實體',
  'menu.enterprise-knowledge-graph.entities.companies': '企業實體',
  'menu.enterprise-knowledge-graph.entities.persons': '人物實體',
  'menu.enterprise-knowledge-graph.entities.products': '產品實體',
  'menu.enterprise-knowledge-graph.entities.documents': '文件實體',
  'menu.enterprise-knowledge-graph.platform': '平台知識引用',
  'menu.enterprise-knowledge-graph.platform.search': '平台實體檢索',
  'menu.enterprise-knowledge-graph.platform.referenced': '已引用實體',
  'menu.enterprise-knowledge-graph.platform.extensions': '平台實體擴展',
  'menu.enterprise-knowledge-graph.relations': '我的關係',
  'menu.enterprise-knowledge-graph.business-links': '業務對象關聯',
  'menu.enterprise-knowledge-graph.graph': '圖譜可視化',
  'menu.enterprise-knowledge-graph.import': '知識導入',
  'menu.enterprise-knowledge-graph.import.data-sources': '數據源管理',
  'menu.enterprise-knowledge-graph.import.tasks': '導入任務',
  'menu.enterprise-knowledge-graph.improvement': '知識完善',
  'menu.enterprise-knowledge-graph.improvement.incomplete-entities':
    '待完善實體',
  'menu.enterprise-knowledge-graph.improvement.duplicates': '疑似重複實體',
  'menu.enterprise-knowledge-graph.ai-assistant': 'AI 知識助手',
  'menu.enterprise-knowledge-graph.settings': '企業圖譜設置',
};
